import { FieldInputProps } from 'formik'
import { ChangeEvent, FocusEvent } from 'react'
import { colors } from 'shared/lib'
import { Country } from 'shared/types/Country'
import styled from 'styled-components'

type CountryDropdownSelectProps = {
  availableCountries: Country[]
  disabled: boolean
  error: boolean
  field: FieldInputProps<any>
  onBlur: (e: FocusEvent) => void
  onChange: (e: ChangeEvent) => void
}
export const CountryDropdownSelect = ({
  availableCountries,
  disabled,
  error,
  field,
  onBlur,
  onChange,
  ...props
}: CountryDropdownSelectProps) => {
  const handleBlur = (event: FocusEvent) => {
    field.onBlur(event)
    onBlur(event)
  }

  const handleChange = (event: ChangeEvent) => {
    field.onChange(event)
    onChange(event)
  }

  return (
    <CountryDropdownSelect.FormSelect
      disabled={disabled}
      error={error}
      {...field}
      {...props}
      onBlur={handleBlur}
      onChange={handleChange}
    >
      <option value="" />
      {availableCountries.map((country: Country) => (
        <option key={country.name} value={country.isoCode}>
          {country.name}
        </option>
      ))}
    </CountryDropdownSelect.FormSelect>
  )
}

CountryDropdownSelect.FormSelect = styled.select<{ error: boolean; disabled: boolean }>`
  min-height: 40px;
  border: 1px solid ${({ error }) => (error ? `${colors.FC2_RED}` : `${colors.FC2_LIGHTEST_GREY}`)};
  border-radius: 0;
  margin-top: 5px;
  font-size: 14px;
  padding: 0 15px;
  color: ${({ disabled }) => (disabled ? colors.FC2_GREY : colors.FC2_BLACK)};
  background-color: ${colors.FC2_WHITE};
  min-width: 100%;
  height: 40px;
  appearance: none;
`
